export const sharePopupToggle = (visible) => {
    const ele = document.getElementById('sharePopup');

    if (visible) {
        ele.style.display = 'block';
    } else {
        ele.style.display = 'none';
    }

    return false;
}
